import React from "react";
import { Typography, Container, Box, Paper, Divider } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";

const Compliance = () => {
  const state = useSelector((state) => state);

  return (
    <div className="main">
      <Sidebar />

      <div
        className="anigrad"
        style={{
          paddingBottom: "50px",
        }}
      >
        <div
          style={{
            height: "50vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "75vw",
              marginLeft: state.auth.isMobile ? "0px" : "0px",
            }}
          >
            <div
              style={{
                fontSize: state.auth.isMobile ? "50px" : "80px",
                color: "yellow",
                zIndex: 999,
                textAlign: state.auth.isMobile ? "center" : "left",
              }}
            >
              Compliance
            </div>

            <div
              style={{
                borderBottom: "2px solid white",
                width: "100%",
                margin: "15px 0px 15px 0px",
              }}
            ></div>
            <div
              style={{
                fontSize: state.auth.isMobile ? "20px" : "3vh",
                color: "white",
                zIndex: 999,
              }}
            >
              Our commitment to ethical and legal business practices
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", backgroundColor: "white" }}>
        <Container
          maxWidth="lg"
          sx={{
            py: 5,
            px: state.auth.isMobile ? 2 : 5,
            mb: 10,
            textAlign: "left",
          }}
        >
          <Box sx={{ mb: 4 }}>
            <Typography variant="body1" paragraph>
              Riches Media Digital operates with full regard for data privacy
              laws, advertising platform policies, and regulatory frameworks
              applicable to the work we undertake. This Compliance Statement
              outlines the policies, checks, and responsibilities we follow
              while delivering digital services. Our approach to compliance is
              practical, enforceable, and updated regularly to reflect changing
              standards in marketing, content use, and data management.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Legal Compliance Framework
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We conduct all business in accordance with the laws of the
              Republic of India and observe regional data protection
              requirements that apply to the clients and platforms we work with.
              Our compliance team monitors updates to IT law, advertising
              restrictions, media content policies, and intellectual property
              rules.
            </Typography>
            <Typography variant="body1" paragraph>
              We also consider global best practices in areas such as cookie
              usage, data storage, and consent-driven outreach when building
              client-facing digital assets. No service is deployed without an
              internal review for lawful operation.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Advertising Platform Compliance
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              All campaigns executed through Riches Media Digital comply with
              the ad policies of respective publishers. This includes but is not
              limited to Google Ads and Meta Ads. Before launching any paid
              campaign, our team reviews platform-specific guidelines covering
              restricted content categories, targeting rules, and landing page
              policies.
            </Typography>
            <Typography variant="body1" paragraph>
              We do not publish or promote ads that violate platform integrity
              standards. This includes prohibited practices such as
              misrepresentation, unverified claims, or data harvesting through
              landing pages. Campaigns that fail internal review do not proceed
              to live publishing until corrections are made and verified.
            </Typography>
            <Typography variant="body1" paragraph>
              Clients are required to ensure that their products, offers, or
              claims are supported by clear documentation where necessary. We
              reserve the right to reject or pause campaigns if compliance risks
              are identified.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Data Handling and Privacy Compliance
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Riches Media Digital does not collect more data than what is
              operationally required. When data is collected, it is stored in
              secure systems with limited access. No data is shared with third
              parties unless it is essential for campaign tracking or authorized
              by the client in writing.
            </Typography>
            <Typography variant="body1" paragraph>
              Our privacy management practices follow principles of lawful use,
              access restriction, and retention control. We keep no client data
              for longer than necessary. Any request for data access,
              modification, or deletion will be honored in line with local data
              protection law and the terms specified in the client agreement.
            </Typography>
            <Typography variant="body1" paragraph>
              We also maintain logs of campaign access, asset handling, and
              document exchange for internal monitoring. Each active project has
              a unique access trail that helps us trace usage or resolve
              concerns quickly.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Copyright, Content, and Licensing
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              All creative content prepared for a client is either developed
              in-house or created using resources that are properly licensed.
              This includes fonts, stock imagery, footage, design templates, and
              ad copy. We do not use unlicensed material in any deliverable.
            </Typography>
            <Typography variant="body1" paragraph>
              If clients provide content for campaigns, they are required to
              confirm that the material is either owned by them or legally
              sourced. In case of any copyright complaints, we investigate the
              claim promptly and pause the disputed material until resolution.
            </Typography>
            <Typography variant="body1" paragraph>
              We retain usage rights over assets produced until final project
              clearance. Clients receive full ownership or usage licenses after
              payment has been completed and formal release is documented.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Internal Review and Quality Control
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Every major deliverable passes through a structured review process
              before it is presented to clients or launched publicly. Our
              internal checks cover content accuracy, brand alignment, technical
              standards, and compliance with campaign terms.
            </Typography>
            <Typography variant="body1" paragraph>
              No ad copy, design, or media asset goes live without this process.
              The same approach applies to reporting dashboards, data export,
              and platform integrations. We maintain internal SOPs to track
              review history, revisions, and approvals.
            </Typography>
            <Typography variant="body1" paragraph>
              In case of compliance errors or overlooked content breaches, we
              act with priority to resolve the matter. The team responsible for
              execution is tasked with remediation, and a follow-up check is
              assigned to prevent repeat issues.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Payment Compliance and Invoicing
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              All payments are collected through secure and legitimate channels.
              Riches Media Digital does not accept payments through unofficial
              accounts or informal gateways. Each invoice includes itemized
              deliverables and applicable service terms. No campaign is billed
              outside the agreed scope unless the change has been approved and
              documented.
            </Typography>
            <Typography variant="body1" paragraph>
              Delayed payments are followed up on formally, and clients are
              reminded of contractual terms before services are paused. Any
              dispute relating to billing or service scope is reviewed
              internally and addressed through direct written communication with
              the client.
            </Typography>
            <Typography variant="body1" paragraph>
              Refund requests are handled in accordance with project timelines
              and asset delivery history. Work already completed is not subject
              to refund unless legally required or contractually agreed upon.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Third-Party Vendor Conduct
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              We engage third-party vendors only after conducting due diligence.
              This includes tool providers, creative freelancers, or technology
              consultants who assist with project delivery. Each vendor is bound
              by non-disclosure and data handling agreements specific to their
              engagement.
            </Typography>
            <Typography variant="body1" paragraph>
              We do not allow external parties to retain access to client
              material after the scope ends. Platform logins, file permissions,
              and project dashboards are revoked as soon as the vendor task is
              completed. Periodic audits are conducted to verify this process.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Incident Response and Accountability
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              If a compliance issue is reported, we conduct an internal
              investigation and prepare a documented action plan. The scope of
              the incident, the persons involved, and the corrective steps are
              logged in our compliance register. Clients are notified of any
              significant issues that may affect their campaigns or data.
            </Typography>
            <Typography variant="body1" paragraph>
              All reports are taken seriously. No concern is dismissed without
              review. We treat compliance as a shared responsibility that
              supports long-term service value.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Client Responsibilities
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Clients are expected to cooperate with compliance checks by
              providing accurate business details, valid campaign content, and
              access credentials that are authorized and secure. Any request for
              document submission or claim verification must be addressed
              promptly to prevent service delays.
            </Typography>
            <Typography variant="body1" paragraph>
              Where the client's product or service operates in a regulated
              industry, it is their responsibility to notify us of relevant
              disclaimers, certifications, or local laws that may apply to
              advertising or communication material.
            </Typography>
            <Typography variant="body1" paragraph>
              We reserve the right to discontinue services if repeated
              compliance breaches are caused by misrepresentation, refusal to
              cooperate, or unwillingness to modify unlawful content.
            </Typography>
          </Box>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ fontWeight: "bold", color: "black" }}
            >
              Updates to Compliance Policies
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" paragraph>
              Riches Media Digital may revise this compliance page as standards
              change or as new laws come into effect. Clients will be informed
              of any major updates that affect service agreements, content
              approval processes, or data governance. Updated compliance terms
              become binding once published and shared with active clients.
            </Typography>
            <Typography variant="body1" paragraph>
              We encourage all clients to remain aware of their own legal
              environment and raise concerns where clarification is needed.
              Compliance is not an optional step but a structural part of how we
              deliver trustworthy services.
            </Typography>
          </Box>
        </Container>
      </div>
      <div style={{ marginTop: "-100px" }} />
      <Footer />
    </div>
  );
};

export default Compliance;
